import { render } from "./descriptions_template.vue?vue&type=template&id=7ed74632"
import script from "./descriptions_template.vue?vue&type=script&lang=js"
export * from "./descriptions_template.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/fields/descriptions_template.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed74632"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed74632', __exports__)) {
    console.log('reload')
    api.reload('7ed74632', __exports__)
  }
  
  module.hot.accept("./descriptions_template.vue?vue&type=template&id=7ed74632", () => {
    console.log('re-render')
    api.rerender('7ed74632', render)
  })

}


export default __exports__